import React from "react";

import { WalletStatus } from "@wallet-manager/node-types/dist/src/postgres/const";

import MultipleSelection from "../../../../components/MultipleSelection,";
import { useTranslation } from "../../../../hooks";

interface IProps {
  value: string[];
  onChange: (value: string[]) => void;
  label?: string;
  disabled?: boolean;
}

const WalletStatusMultipleSelection = (props: IProps) => {
  const { value, onChange, label, disabled } = props;

  const { t } = useTranslation("tronWalletResourceBalance");

  const enumData = Object.fromEntries(
    Object.entries(WalletStatus)
      .filter(([label, value]) => {
        return [-1, 1].includes(Number(value));
      })
      // descending order by value
      .sort((a, b) => Number(b[1]) - Number(a[1]))
  );

  return (
    <MultipleSelection
      label={label || t("psWalletStatus")}
      value={value}
      onChange={onChange}
      enumData={enumData}
      disabled={disabled}
      isNoSorting
    />
  );
};

export default WalletStatusMultipleSelection;
